/* eslint-disable react/jsx-props-no-spreading */
import React from "react";

import { Button, ButtonProps, NeoColor } from "@noom/wax-component-library";

type NeoSupportedColorScheme = "primary" | "secondary";

type NeoButtonProps = ButtonProps & {
  colorScheme?: NeoSupportedColorScheme;
};

/**
 * NeoButton is a custom button component that is used to style the button
 * using the Neo styles for the Connect Health Records flow while we still
 * run the Legacy Buyflow / Compass theme in the app.
 */
export const NeoButton: React.FC<NeoButtonProps> = ({
  children,
  colorScheme = "primary",
  ...rest
}) => {
  const colorSchemeStyles: Record<NeoSupportedColorScheme, ButtonProps> = {
    primary: {
      backgroundColor: NeoColor.blue.lagoon,
      textColor: NeoColor.greyscale.white,
      _active: { backgroundColor: NeoColor.blue.lagoonShade1 },
      _hover: { backgroundColor: NeoColor.blue.lagoonShade1 },
    },
    secondary: {
      backgroundColor: NeoColor.greyscale.white,
      border: `1px solid ${NeoColor.greyscale.black}`,
      textColor: NeoColor.greyscale.black,
      _active: {
        backgroundColor: NeoColor.greyscale.clear,
        borderWidth: "2px",
      },
      _hover: {
        backgroundColor: NeoColor.greyscale.clear,
        borderWidth: "2px",
      },
    },
  };

  const defaultStyles = colorSchemeStyles[colorScheme];

  return (
    <Button
      borderRadius="full"
      size="xl"
      type="submit"
      width="100%"
      {...defaultStyles}
      {...rest}
    >
      {children}
    </Button>
  );
};
